
export const GET_INVOICES = "GET_INVOICES"
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS"
export const GET_INVOICES_FAIL = "GET_INVOICES_FAIL"

export const UPDATE_INVOICE_STATUS = "UPDATE_INVOICE_STATUS"
export const UPDATE_INVOICE_STATUS_SUCCESS = "UPDATE_INVOICE_STATUS_SUCCESS"
export const UPDATE_INVOICE_STATUS_FAIL = "UPDATE_INVOICE_STATUS_FAIL"
